const beatData = {
  slug: "beat",
  name: "Honda BeAT",

  hero: {
    shortDescription:
      "Skutik irit dan gesit untuk mobilitas harian dengan desain sporty dan modern",

    variants: [
      {
        key: "cbs",
        label: "CBS",
        fullName: "Honda BeAT Sporty CBS Hard Rock Black",
        startPrice: 19174000,
      },
      {
        key: "deluxe",
        label: "Deluxe",
        fullName: "Honda BeAT Sporty Deluxe Matte Green",
        startPrice: 20469000,
      },
      {
        key: "smartkey",
        label: "Smart Key",
        fullName: "Honda BeAT Sporty Deluxe SmartKey Matte Blue",
        startPrice: 20999000,
      },
      {
        key: "street-white",
        label: "Street",
        fullName: "Honda BeAT Street White",
        startPrice: 20469000,
      },
      {
        key: "street-brown",
        label: "Street",
        fullName: "Honda BeAT Street Brown",
        startPrice: 20469000,
      },
      {
        key: "street-black",
        label: "Street",
        fullName: "Honda BeAT Street Black",
        startPrice: 20469000,
      },
    ],

    slides: [
      {
        variantKey: "cbs",
        image: "/assets/motor/produk/beat/Honda-Beat-Sporty-CBS-Hard-Rock-Black-1.webp",
        specs: {
          engine: "109,5 cc, 4 Langkah, SOHC, eSP",
          power: "6,6 kW (9,0 PS) / 7.500 rpm",
          smartKey: false,
        },
      },
      {
        variantKey: "deluxe",
        image: "/assets/motor/produk/beat/Honda-Beat-Sporty-Deluxe-Matte-Green.webp",
        specs: {
          engine: "109,5 cc, 4 Langkah, SOHC, eSP",
          power: "6,6 kW (9,0 PS) / 7.500 rpm",
          smartKey: false,
        },
      },
      {
        variantKey: "smartkey",
        image: "/assets/motor/produk/beat/Honda-Beat-Sporty-Deluxe-SmartKey-Matte-Blue-1.webp",
        specs: {
          engine: "109,5 cc, 4 Langkah, SOHC, eSP",
          power: "6,6 kW (9,0 PS) / 7.500 rpm",
          smartKey: true,
        },
      },
      {
        variantKey: "street-white",
        image: "/assets/motor/produk/beat/Honda-Beat-Street-White.webp",
        specs: {
          engine: "109,5 cc, 4 Langkah, SOHC, eSP",
          power: "6,6 kW (9,0 PS) / 7.500 rpm",
          smartKey: false,
        },
      },
      {
        variantKey: "street-brown",
        image: "/assets/motor/produk/beat/Honda-Beat-Street-Brown-1.webp",
        specs: {
          engine: "109,5 cc, 4 Langkah, SOHC, eSP",
          power: "6,6 kW (9,0 PS) / 7.500 rpm",
          smartKey: false,
        },
      },
      {
        variantKey: "street-black",
        image: "/assets/motor/produk/beat/Honda-Beat-Street-Black-2.webp",
        specs: {
          engine: "109,5 cc, 4 Langkah, SOHC, eSP",
          power: "6,6 kW (9,0 PS) / 7.500 rpm",
          smartKey: false,
        },
      },
    ],
  },

  description: {
    sections: [
      {
        type: "paragraph",
        text:
          "Honda BeAT merupakan skutik paling populer di Indonesia yang dirancang untuk memenuhi kebutuhan mobilitas harian dengan konsumsi bahan bakar yang sangat efisien serta desain yang modern dan ringan.",
      },
      {
        type: "paragraph",
        text:
          "Dibekali mesin 110cc enhanced Smart Power (eSP), Honda BeAT menawarkan performa responsif, ramah lingkungan, dan biaya perawatan yang terjangkau untuk penggunaan sehari-hari.",
      },
      {
        type: "heading",
        text: "Desain Ringan dan Sporty",
      },
      {
        type: "paragraph",
        text:
          "Dengan rangka eSAF (enhanced Smart Architecture Frame), Honda BeAT memiliki bobot yang ringan sehingga mudah dikendalikan di jalanan perkotaan. Varian Street hadir dengan setang telanjang untuk tampilan yang lebih agresif.",
      },
      {
        type: "heading",
        text: "Irit Bahan Bakar dan Fitur Fungsional",
      },
      {
        type: "paragraph",
        text:
          "Fitur Idling Stop System (ISS) dan PGM-FI membantu meningkatkan efisiensi bahan bakar. Sistem Smart Key tersedia pada varian tertentu untuk keamanan dan kemudahan berkendara.",
      },
    ],
  },

  specificationsDetail: {
    mesin: [
      ["Tipe Mesin", "4 Langkah, SOHC, eSP"],
      ["Sistem Suplai Bahan Bakar", "PGM-FI"],
      ["Kapasitas Mesin", "109,5 cc"],
      ["Daya Maksimum", "6,6 kW (9,0 PS) / 7.500 rpm"],
      ["Torsi Maksimum", "9,3 Nm / 5.500 rpm"],
      ["Transmisi", "Otomatis, V-Matic"],
    ],

    rangka: [
      ["Tipe Rangka", "enhanced Smart Architecture Frame (eSAF)"],
      ["Suspensi Depan", "Teleskopik"],
      ["Suspensi Belakang", "Lengan Ayun dengan Peredam Kejut Tunggal"],
      ["Rem Depan", "Cakram"],
      ["Rem Belakang", "Tromol"],
    ],

    dimensi: [
      ["Panjang x Lebar x Tinggi", "1.876 x 669 x 1.080 mm"],
      ["Tinggi Jok", "742 mm"],
      ["Jarak Sumbu Roda", "1.255 mm"],
      ["Berat", "89–90 kg"],
    ],

    kapasitas: [
      ["Kapasitas Tangki Bahan Bakar", "4,2 Liter"],
      ["Kapasitas Bagasi", "12 Liter"],
    ],

    kelistrikan: [
      ["Sistem Pengapian", "Full Transistorized"],
      ["Tipe Aki", "12V MF"],
      ["Sistem Starter", "Electric & Kick Starter"],
    ],
  },

  fullFeatures: {
    title: "Fitur Unggulan Honda BeAT",
    items: [
      {
        title: "Enhanced Smart Power (eSP)",
        desc:
          "Teknologi mesin Honda yang meningkatkan efisiensi bahan bakar, performa, dan ramah lingkungan.",
      },
      {
        title: "Idling Stop System (ISS)",
        desc:
          "Mesin mati otomatis saat berhenti beberapa detik untuk menghemat bahan bakar. *Tersedia pada varian tertentu.",
      },
      {
        title: "Honda Smart Key System",
        desc:
          "Sistem keyless dengan alarm dan answer back system untuk keamanan ekstra. *Tersedia pada varian Smart Key.",
      },
      {
        title: "Combi Brake System (CBS)",
        desc:
          "Sistem pengereman yang membagi daya rem depan dan belakang secara seimbang untuk pengereman lebih stabil.",
      },
      {
        title: "Panel Meter Digital",
        desc:
          "Panel meter digital modern dengan informasi lengkap dan mudah dibaca.",
      },
      {
        title: "Rangka eSAF",
        desc:
          "Rangka generasi terbaru yang lebih ringan dan kokoh untuk kenyamanan dan kemudahan pengendalian.",
      },
    ],
  },
};

export default beatData;
